export default __webpack_public_path__ + "205544b.png";